import { useUser } from 'lib/auth';
import useSWR from 'swr';
import { Tenant } from 'utils/tenants';

import { getAccountHasBudget } from '../api/get-account-has-budget';

export const useUserAccountHasBudget = () => {
  const { roles, accountId, tenantId } = useUser();

  const {
    data: hasBudget,
    error,
    isLoading,
  } = useSWR(`/dashboards/has-budget-to-create-programs/${accountId}`, () =>
    getAccountHasBudget(accountId, roles, tenantId as Tenant)
  );

  return { hasBudget, error, isLoading };
};
